import Agent from "./agent.jsx";
export const getAllServicesGroup = async (shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  return await requests.get(`/ServiceGroup/${shopId}`, token, shopId);
};
export const createNewServiceGroup = async (serviceGroupName, shopId) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  const token = localStorage.getItem("authToken");
  const params = {
    ShopId: shopId,
    Name: serviceGroupName.name,
    OrderNumber: serviceGroupName.orderNumber,
  };
  return await requests.post(`/ServiceGroup`, params, token, shopId);
};

export const deleteServiceGroup = async (shopId, serviceGroupId) => {
  try {
    const token = localStorage.getItem("authToken");

    const { requests } = Agent();
    return await requests.del(
      `/ServiceGroup?id=${serviceGroupId}&shopId=${shopId}`,
      token,
      shopId,
    );
  } catch (error) {
    console.error(
      "Error updating service:",
      error.response?.data || error.message,
    );
    throw error;
  }
};
export const updateServiceGroup = async (editService, shopId) => {
  const token = localStorage.getItem("authToken");

  const params = {
    ShopId: shopId,
    Id: editService.id,
    Name: editService.name,
    OrderNumber: editService.orderNumber,
  };
  const { requests } = Agent();
  return await requests.put(`/ServiceGroup/`, params, token, shopId);
};
